import { getDICOMDate, getDICOMTime } from '~/domain/dicom/utils';

/**
 * Escapes a single CSV cell value per RFC 4180.
 * Wraps the value in double-quotes if it contains a comma, double-quote,
 * or newline, and escapes any embedded double-quotes by doubling them.
 * Cells that a spreadsheet would evaluate as a formula (leading =, +, @,
 * or a leading - that is not a plain negative number) are prefixed with
 * an apostrophe to force text interpretation (CSV injection mitigation).
 */
export function csvEscapeCell(value: string): string {
    let cell = value;
    if (
        /^[=+@\t\r]/.test(cell) ||
        (cell.startsWith('-') && !/^-\d+(\.\d+)?$/.test(cell))
    ) {
        cell = `'${cell}`;
    }
    if (/[,'"\n\r]/.test(cell)) {
        return `"${cell.replace(/"/g, '""')}"`;
    }
    return cell;
}

// encodeURIComponent, not encodeURI: encodeURI leaves '#' unescaped, so a
// cell like "Brain #3" would become the data: URL's fragment and truncate the
// download. The scheme prefix stays literal (its ':' ';' ',' must survive).
export const createCSVContent = (header: string, rows: string[]) => {
    const csvContent = 'data:text/csv;charset=utf-8,';
    return csvContent + encodeURIComponent(header + rows.join(''));
};

export const createJSONContent = (jsonData: object[]) => {
    const jsonContent = 'data:text/json;charset=utf-8,';
    return jsonContent + encodeURIComponent(JSON.stringify(jsonData));
};

/** A date and time as DICOM strings joined by an underscore, for a file name. */
export function exportFileStamp(now: Date): string {
    return `${getDICOMDate(now)}_${getDICOMTime(now)}`;
}

export const downloadCreatedFile = (encodedUri: string, filename: string) => {
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
